// 全画面のカメラと失敗モーダルを重ねる層。どちらも枠の一覧の上に出るため、フォームから切り離してある
import { IdentityVerifyErrorDialog, RetakeFailureDisplay } from '@/components/molecules/checkIn/identity-verify-error-dialog'
import { IdentityVerifyCamera } from '@/components/organisms/checkIn/identity-verify-camera'
import { DocumentCameraPreset } from '@/hooks/use-document-slots'
import React from 'react'

type Props = {
  cameraPreset: DocumentCameraPreset
  activeCapture?: {
    instruction: string
    onCapture: (blob: Blob, isManual: boolean) => void | Promise<void>
    onCancel: () => void
  }
  failure?: {
    slotId: string
    retake?: RetakeFailureDisplay
    onDismiss: () => void
  }
}

export const IdentityVerifyCaptureLayer: React.FC<Props> = ({ cameraPreset, activeCapture, failure }) => (
  <>
    {activeCapture && (
      <IdentityVerifyCamera
        cameraInstruction={activeCapture.instruction}
        guide={cameraPreset.guide}
        guideImageUrl={cameraPreset.guideImageUrl}
        shutter={cameraPreset.shutter}
        autoDetect={cameraPreset.autoDetect}
        onCapture={activeCapture.onCapture}
        onCancel={activeCapture.onCancel}
      />
    )}
    {failure && <IdentityVerifyErrorDialog key={failure.slotId} retake={failure.retake} onDismiss={failure.onDismiss} />}
  </>
)
